'use client';

import { useEffect, useState } from 'react';
import { getAllStories } from '@/services/storyApiService';
import { Story } from '@/utils/types';
import StoryCard from '@/components/StoryCard';
import AdsterraBanner from '@/components/AdsterraBanner';

export default function Home() {
  const [stories, setStories] = useState<Story[]>([]);
  const [filteredStories, setFilteredStories] = useState<Story[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const loadStories = async () => {
      try {
        const data = await getAllStories();
        setStories(data);
        setFilteredStories(data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    loadStories();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredStories(stories);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = stories.filter(
        (story) =>
          story.title.toLowerCase().includes(query) ||
          story.author.toLowerCase().includes(query) ||
          story.genre.toLowerCase().includes(query) ||
          story.description.toLowerCase().includes(query)
      );
      setFilteredStories(filtered);
    }
  }, [searchQuery, stories]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 pb-16">
      {filteredStories.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-lg text-muted">No stories found</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
            {filteredStories.map((story, index) => (
              <div key={story._id}>
                {index === 4 && <AdsterraBanner position="middle" />}
                <StoryCard story={story} />
              </div>
            ))}
          </div>
          <AdsterraBanner position="bottom" />
        </>
      )}
    </div>
  );
}
